(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('Medal', Medal);

    Medal.$inject = ['$resource'];

    function Medal ($resource) {
        var resourceUrl =  'api/medals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
